import { render, staticRenderFns } from "./DiscountLine.vue?vue&type=template&id=542129df&scoped=true&"
import script from "./DiscountLine.vue?vue&type=script&lang=js&"
export * from "./DiscountLine.vue?vue&type=script&lang=js&"
import style0 from "./DiscountLine.vue?vue&type=style&index=0&id=542129df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542129df",
  null
  
)

export default component.exports